var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sk-folding-cube",style:({ width: _vm.size , height: _vm.size })},[_c('div',{staticClass:"sk-cube1 sk-cube"}),_vm._v(" "),_c('div',{staticClass:"sk-cube2 sk-cube"}),_vm._v(" "),_c('div',{staticClass:"sk-cube4 sk-cube"}),_vm._v(" "),_c('div',{staticClass:"sk-cube3 sk-cube"})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1aecf717","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/spinner/Spinner-Iqos.vue
// module id = Fno3
// module chunks = 44